import type { Papel } from "@ghm/domain";

import { http } from "@/lib/http";

/**
 * O que o servidor conta sobre quem esta logado.
 *
 * Espelha `publico()` em `apps/api/src/auth-routes.ts`. Nunca traz hash, token
 * nem id de sessao — o cookie e `httpOnly` justamente para que o JavaScript da
 * pagina nao tenha como alcancar a credencial.
 */
export interface OrganizacaoDoUsuario {
  organizationId: string;
  nome: string;
  slug: string;
  papel: Papel;
}

export interface UsuarioSessao {
  id: string;
  login: string;
  nome: string;
  email: string | null;
  papel: Papel;
  organizacao: OrganizacaoDoUsuario | null;
  organizacoes: OrganizacaoDoUsuario[];
}

/**
 * `desligada` NAO e um erro: e a bancada.
 *
 * A API sobe sem identidade quando nao ha Postgres — o modo em que o
 * configurador e o simulador trabalham. O front precisa distinguir isso de
 * "sessao expirada", porque a resposta certa e oposta: num caso abre o painel,
 * no outro pede login.
 */
export type EstadoAutenticacao =
  | { modo: "desligada" }
  | { modo: "autenticado"; usuario: UsuarioSessao }
  | { modo: "anonimo" };

interface RespostaMe {
  autenticacao?: "ligada" | "desligada";
  usuario: UsuarioSessao | null;
}

export async function buscarSessao(signal?: AbortSignal): Promise<EstadoAutenticacao> {
  const resposta = await http.get<RespostaMe>("/api/auth/me", { signal });
  if (resposta.autenticacao === "desligada") return { modo: "desligada" };
  if (!resposta.usuario) return { modo: "anonimo" };
  return { modo: "autenticado", usuario: resposta.usuario };
}

export async function entrar(login: string, senha: string): Promise<UsuarioSessao> {
  const resposta = await http.post<{ usuario: UsuarioSessao }>("/api/auth/login", {
    login,
    senha,
  });
  return resposta.usuario;
}

export async function sair(): Promise<void> {
  await http.post<{ ok: boolean }>("/api/auth/logout");
}
